module.exports = __webpack_public_path__ + "img/iconCC-Social8.b60f8b27.png";